import React, { useEffect, useState } from 'react'
import { Breadcrumb, Col, Form, Row } from 'react-bootstrap'
import SecBTN from '../../UI/SecBTN'
import Input from '../../UI/Input/Input'
import Graybg from '../../UI/Graybg'
import classes from './style.module.css'
import Card from '../../UI/Card/Card'
import BulkQUestion from './BulkQUestion'
import TopicWiseQuestionHtml from './TopicWiseQuestionHtml'
import QuestionModule from './QuestionModule'
import SampleQuestionModule from './SampleQuestionModule'
import SampleQuestionSolution from './SampleQuestionSolution'
import userService from '../../app/services/user.service'
import BulkQuestionTranslation from './BulkQuestionTranslation'
import BulkSolutionTranslation from './BulkSolutionTranslation'

const BulkQuestionRequest = () => {
  // Panel buttons activity
  const navBtn = [
    "Bulk Question Request",
    "Topic Wise Question Html",
    "Question Module",
    "Sample Question Module",
    "Question Module with Solution",
    "Bulk Translation",
    "Bulk Solution Generation"
  ];
  const [navBtnActive, setNavBtnActive] = useState(navBtn[0]);
  const [subjectList,setSubjectList] =useState([]);
  const downloadFile = () => {
    console.log(window.location.origin)
    fetch(window.location.origin+"/files/jeemains.xlsx").then((response) => {
      response.blob().then((blob) => {
       
          // Creating new object of PDF file
          const fileURL =
              window.URL.createObjectURL(blob);
               
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = "jeemains.xlsx";
          alink.click();
      });
  });
  }

  const fetchSubjectList = () => {
    userService.getSubjectList()
    .then((res) => {
      setSubjectList(res.data.data);
    })
    .catch(err => {
      console.error(err);
    })
  }

  useEffect(() => {
    fetchSubjectList();
  },[])
  return (
    <div className="section">
      <h4>Bulk Question</h4>
      <Breadcrumb>
        <Breadcrumb.Item>Bulk Question</Breadcrumb.Item>
        <Breadcrumb.Item active>{navBtnActive}</Breadcrumb.Item>
      </Breadcrumb>
      <Graybg>
      <div className={`mb-4 ${classes.navPanel}`}>
          {navBtn.map((navItem) => {
            return (
              <button
                key={navItem}
                className={
                  navItem === navBtnActive
                    ? classes.navItemActive
                    : classes.navItem
                }
                onClick={() => setNavBtnActive(navItem)}
              >
                {navItem}
              </button>
            );
          })}
        </div>
        <Card className={`${classes.card} printable`}>
         {navBtnActive === navBtn[0]  && <BulkQUestion/>}
         {navBtnActive === navBtn[1]  && <TopicWiseQuestionHtml subjectList={subjectList} />}
         {navBtnActive === navBtn[2]  && <QuestionModule/>}
         {navBtnActive === navBtn[3]  && <SampleQuestionModule/>}
         {navBtnActive === navBtn[4]  && <SampleQuestionSolution/>}
         {navBtnActive === navBtn[5]  && <BulkQuestionTranslation/>}
         {navBtnActive === navBtn[6]  && <BulkSolutionTranslation/>}
        </Card>
        
      </Graybg>
    </div>
  )
}

export default BulkQuestionRequest